/*
 * decaffeinate suggestions:
 * DS101: Remove unnecessary use of Array.from
 * DS102: Remove unnecessary code created because of implicit returns
 * DS201: Simplify complex destructure assignments
 * DS206: Consider reworking classes to avoid initClass
 * DS207: Consider shorter variations of null checks
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
/* eslint no-shadow:0, eqeqeq:0, prefer-const:0 */
let AJAXRPC;
const Alerts = require('app/scripts/views/lib/alerts');
const ApiError = require('app/scripts/network/api-error');
const Auth = require('app/scripts/db/auth');
const Backbone = require('app/scripts/lib/backbone');
const Batcher = require('./batcher');
const Monitor = require('app/scripts/lib/monitor');
const Promise = require('bluebird');
const _ = require('underscore');
const l = require('app/scripts/lib/localize');
const log = require('app/scripts/debug/log');
const f = require('effing');
const syncError = require('app/scripts/debug/sync-error');
const templates = require('app/scripts/views/internal/templates');
const { Noun, Verb, trackUe } = require('@trello/analytics');

const makeErrorEnum = require('app/scripts/lib/make-error-enum');

const RpcError = makeErrorEnum('RPC', ['SyncError', 'BatchError']);

const tryParseJSON = function (str) {
  try {
    return JSON.parse(str);
  } catch (error) {
    return null;
  }
};

// Here we use polling instead of any socket or Comet-style interaction, so we have to fake out
// anything that relies on server push (e.g. subscription).
module.exports = AJAXRPC = (function () {
  AJAXRPC = class AJAXRPC {
    static initClass() {
      _.extend(this.prototype, Backbone.Events);
    }

    constructor(delegate) {
      this.delegate = delegate;
      this.idBoardToPoll = null;
      this.modelIxUpdate = {};
      this.msPoll = 5000;
      this.msPollIdle = 20000;
      this.ajaxSessionId = Math.random().toString().substring(2);
      while (this.ajaxSessionId.length < 16) {
        this.ajaxSessionId += '0';
      }

      this.consecutiveFailures = 0;
      this.consecutiveFailuresAllowed = 300;

      this.totalFailures = 0;
      this.totalFailuresAllowed = 1000;
    }

    subscribe(modelType, idModel, tags, next) {
      return typeof next === 'function' ? next() : undefined;
    }

    unsubscribe(modelType, idModel, next) {
      return typeof next === 'function' ? next() : undefined;
    }

    // There's no resync logic over AJAX; just wait til the next poll
    resync() {}

    _getPollLength() {
      if (Auth.isLoggedIn() && Monitor.getStatus() === 'active') {
        return this.msPoll;
      } else {
        return this.msPollIdle;
      }
    }

    stopPolling() {
      if (this._pollingTimeout != null) {
        clearTimeout(this._pollingTimeout);
        return delete this._pollingTimeout;
      }
    }

    poll() {
      return (this._pollingTimeout = setTimeout(
        () => {
          if (
            this.consecutiveFailures >= this.consecutiveFailuresAllowed ||
            this.totalFailures >= this.totalFailuresAllowed
          ) {
            this.trigger('connect_failed');
            return;
          }

          return this.doPoll((err) => {
            if (err != null) {
              if (err === 'syncError') {
                // Stop polling; we're currently requesting a refresh
                return;
              }
              this.trigger('connecting');
              ++this.consecutiveFailures;
              ++this.totalFailures;
            } else {
              if (this.consecutiveFailures > 0) {
                this.trigger('reconnect');
              }
              this.consecutiveFailures = 0;
            }

            if (this._pollingTimeout != null) {
              return this.poll();
            }
          });
        },

        this._getPollLength(),
      ));
    }

    // SocketRPC uses doPoll to sync up after it loses its connection, and thus
    // needs to override the models to poll for and be the Backbone event emitter
    // for the response messages. It would be nice to restructure this.
    doPoll(...args) {
      let idModel;
      let adjustedLength = Math.max(args.length, 1),
        [idModels, messageHandler] = Array.from(
          args.slice(0, adjustedLength - 1),
        ),
        next = args[adjustedLength - 1];
      const subscriptions = [];
      if (typeof messageHandler === 'undefined' || messageHandler === null) {
        messageHandler = this;
      }
      if (_.isArray(idModels)) {
        for (idModel of Array.from(idModels)) {
          subscriptions.push(this.delegate.currentSubscriptions[idModel]);
        }
      } else if (typeof idModels === 'undefined' || idModels === null) {
        for (idModel in this.delegate.currentSubscriptions) {
          const subscription = this.delegate.currentSubscriptions[idModel];
          subscriptions.push(subscription);
        }
      } else {
        log('rpc', `Bad argument to doPoll: ${idModels}`);
        return;
      }

      if (!_.isEmpty(subscriptions)) {
        return this._doPoll(subscriptions, messageHandler, next);
      } else {
        log('rpc', `No models to poll for ${idModels}`);
        return typeof next === 'function' ? next() : undefined;
      }
    }

    _doPoll(subscriptions, messageHandler, next) {
      const batcher = new Batcher({
        headers: { 'X-Trello-Polling': true },
      });

      const batchRequests = subscriptions.map(
        ({ modelType, idModel, ixLastUpdate, tags }) => {
          const url =
            `/${modelType}/${idModel}/deltas` +
            '?ixLastUpdate=' +
            encodeURIComponent(ixLastUpdate.toString()) +
            '&tags=' +
            encodeURIComponent(tags.join(','));
          return batcher
            .request(url)
            .tap((res) => {
              if (res.syncError != null) {
                return Promise.reject(RpcError.SyncError(res.syncError));
              }

              this.delegate.setIxLastUpdate(
                idModel,
                res.modelIxUpdate[idModel],
              );

              _.chain(res.messages != null ? res.messages : [])
                .map(tryParseJSON)
                .compact()
                .forEach(({ notify, idModelChannel }) => {
                  messageHandler.trigger(
                    notify.event,
                    _.extend({ idModelChannel }, notify),
                  );
                });

              this.dateLastMessage = Date.now();
            })
            .catch(ApiError, () => {
              // Unlike a SyncError, an ApiError here isn't sufficient for us to
              // stop processing other batch results.
              return this.delegate.handleInvalidSubscription(idModel);
            });
        },
      );

      Promise.all(batchRequests)
        .catch(RpcError.SyncError, (err) => {
          syncError(err, {
            isUsingSocket: messageHandler !== this,
            dateLastMessage: messageHandler.dateLastMessage,
          });
          return this.stopPolling();
        })
        .catch(Batcher.BatchFailure, function () {})
        // When the batch call fails, this is going to be emitted
        // for each inner request and we'll be catching the first
        // one. But we don't care about this -- we'll look for and
        // handle the BatchFailure on the send call instead.
        .done();

      return batcher
        .send()
        .catch(Batcher.BatchFailure, ({ message, error }) =>
          Promise.reject(RpcError.BatchError(message, { error })),
        )
        .catch(function (e) {
          log('rpc', 'Loading batched deltas via ajax failed');
          trackUe({
            category: Noun.WEBSOCKET_DISCONNECTION,
            verb: Verb.SHOWS,
            directObj: Noun.CONNECTION_FAILURE_ALERT,
            method: 'by failing to fetch deltas',
          });
          const msg = l('alerts.could not connect');
          return Alerts.showHtml(
            templates.fill(
              require('app/scripts/views/templates/connect_failed'),
              { msg },
            ),
            'error',
            'connectionDead',
          );
        })
        .nodeify(next)
        .done();
    }
  };
  AJAXRPC.initClass();
  return AJAXRPC;
})();
